import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';

const HeroModern = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-green-900 via-emerald-800 to-green-950">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.1),transparent_50%)] animate-pulse"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(255,255,255,0.1),transparent_50%)] animate-pulse" style={{animationDelay: '1s'}}></div>
      </div>

      {/* Content Container */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        {/* NPOP Badge */}
        <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-md rounded-full border border-white/20 mb-8">
          <CheckCircle className="text-green-300" size={20} />
          <span className="text-white font-semibold text-sm">NPOP Certified Organic Exporter</span>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
          <span className="text-white drop-shadow-lg">Premium Organic Products</span>
          <span className="block text-green-300 drop-shadow-lg mt-2">From India to the World</span>
        </h1>

        {/* Description */}
        <p className="text-xl sm:text-2xl text-green-50 mb-12 max-w-3xl mx-auto leading-relaxed">
          Certified organic turmeric, ginger, buckwheat, and black cardamom. 
          Direct from organic farms to global markets.
        </p>

        {/* Product Highlights */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12 max-w-4xl mx-auto">
          {[
            'Turmeric Powder & Flakes',
            'Ginger Powder & Flakes',
            'Buckwheat',
            'Black Cardamom'
          ].map((product, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <CheckCircle className="text-green-300 mx-auto mb-3" size={32} />
              <p className="text-white font-medium text-sm">{product}</p>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#products"
            className="inline-flex items-center px-8 py-4 bg-white text-green-900 rounded-full font-semibold text-lg shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
          >
            Explore Products
            <ArrowRight className="ml-2" size={20} />
          </a>
          <a
            href="#contact"
            className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-white text-white rounded-full font-semibold text-lg hover:bg-white hover:text-green-900 transition-all duration-300"
          >
            Request Quote
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-white/80 text-sm">
          <div className="flex items-center gap-2">
            <CheckCircle size={16} className="text-green-300" />
            <span>NPOP Certified</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle size={16} className="text-green-300" />
            <span>Direct Farm Sourcing</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle size={16} className="text-green-300" />
            <span>International Quality</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroModern;
